export class ProviderMedicationMap {
    providerMedicationMapId: number;
    providerId: number;
    createdBy: number;
    modifiedBy?: number;
    createdDate: Date;
    modifiedDate?: Date;
    active: boolean;
}